import React, { useContext, useEffect } from 'react'
import { useFeatures } from '../../hooks/Features/useFeatures'
import { CategoryContext } from '../../context api/Category/CategoryContext'
import { SubCategoryContext } from '../../context api/SubCategory/SubCategoryContext'

import { useCategory } from '../../hooks/Features/useCategory'
import { useProduct } from '../../hooks/Features/useProduct'
import { ProductContext } from '../../context api/Product/ProductContext'
import { useTax } from '../../hooks/CompanyConfiguration/useTax'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'

import { sortByName } from '../../shared/constants'
import useValidation from '../../hooks/Validation/useValidation'

import CustomAddForm from '../version-4/MasterForms/CustomAddForm'

export default function AddProduct({ state, setState }) {
  const { selectCategory, selectSubCategory, name, color, sku, distributorPrice, dealerPrice, stocks, description, mustItem, discount, tax, primaryVariant, secondaryVariant, active } = state

  const { getAllsubCategoryByCategory } = useFeatures()
  const { getAllCategories } = useCategory()
  const { getAllProducts, getAllSecondaryVariant, allSecondaryVariant } = useProduct()
  const { getAllTax } = useTax()
  const { categories } = useContext(CategoryContext)
  const { products } = useContext(ProductContext)
  const { subcategories } = useContext(SubCategoryContext)
  const { taxes } = useContext(ConfigurationContext)

  useEffect(() => {
    if (selectCategory) {
      getAllsubCategoryByCategory({ categoryId: selectCategory })
    }
  }, [selectCategory])

  useEffect(() => {
    if (selectCategory && selectSubCategory) {
      getAllSecondaryVariant({ categoryId: selectCategory, subCategoryId: selectSubCategory })
    }
  }, [selectCategory, selectSubCategory])

  useEffect(() => {
    getAllCategories()
    getAllProducts()
    getAllTax()
  }, [])

  const input = [
    {
      label: 'Select Category',
      value: selectCategory,
      name: 'selectCategory',
      fieldName: 'categoryName',
      fieldValue: '_id',
      options: sortByName(categories, 'categoryName'),
    },
    {
      label: 'Select Sub Category',
      value: selectSubCategory,
      name: 'selectSubCategory',
      fieldName: 'name',
      fieldValue: '_id',
      options: sortByName(subcategories),
    },
    { label: 'Name', value: name, name: 'name' },
    { label: 'Color', value: color, name: 'color' },
    { label: 'SKU', value: sku, name: 'sku' },
    {
      label: 'Primary Variant',
      value: primaryVariant,
      name: 'primaryVariant',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
      fieldName: 'label',
      fieldValue: 'value',
      noValidate: true,
    },
    {
      label: 'Distributor Price',
      value: distributorPrice,
      name: 'distributorPrice',
      type: 'NUMBER',
      noValidate: true,
    },
    { label: 'MRP', value: dealerPrice, name: 'dealerPrice', type: 'NUMBER' },
    { label: 'Maximum Discount', value: discount, name: 'discount', type: 'NUMBER' },
    // {
    //   label: 'Tax',
    //   value: tax,
    //   name: 'tax',
    //   select: true,
    //   options: taxes,
    //   fieldName: 'name',
    //   fieldValue: '_id',
    //   noValidate: true,
    // },
    { label: 'Dimensions (L,B,H)', value: stocks, name: 'stocks', select: false, noValidate: true },
    { label: 'Description', value: description, name: 'description', select: false },
    {
      label: 'Secondary Variants',
      value: secondaryVariant,
      name: 'secondaryVariant',
      type: 'MULTI',
      fieldName: 'name',
      fieldName2: 'sku',
      fieldValue: '_id',
      grid: 12,
      noValidate: true,
      handleChange: (val) => setState({ ...state, secondaryVariant: val }),
      options: sortByName(allSecondaryVariant, 'sku'),
      noDisplay: primaryVariant ? false : true,
    },
    {
      label: 'Must Item',
      value: mustItem,
      name: 'mustItem',
      options: sortByName(products, 'name'),
      grid: 12,
      fieldName: 'name',
      fieldName2: 'sku',
      fieldValue: '_id',
      handleChange: (val) => setState({ ...state, mustItem: val }),
      type: 'MULTI',
      noValidate: true,
    },
    {
      label: 'Primary Image',
      name: 'primaryImage',
      type: 'IMAGE',
    },
    {
      label: 'Secondary Image',
      name: 'secondaryImage',
      type: 'IMAGE',
    },
    { label: 'Other Media', name: 'images', type: 'IMAGE', multiple: true, accept: "image/*, video/*" },

    { label: 'Status', value: active, name: 'active', type: 'ACTIVE', noValidate: true },
  ]

  return <CustomAddForm state={state} setState={setState} data={input} />
}
